// Delete Serial Use Case

import {InventoryRepository} from '../repository/InventoryRepository';

export class DeleteSerialUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (id: string): Promise<void> {
    await this.inventoryRepository.deleteSerial(id);
  }
}


